module.exports = __webpack_public_path__ + "img/thumbnail_HoneyBadger_m_melanistic.099e981b.png";